(() => {
  const money = new Intl.NumberFormat('es-CO', {style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0});
  const init = () => {
    const params = new URLSearchParams(location.search);
    const legacyFamily = params.get('familia');
    if (/^\/collections\/all\/?$/.test(location.pathname) && ['accesorios', 'coccion', 'lavado', 'conservacion'].includes(legacyFamily)) {
      location.replace('/collections/' + legacyFamily);
      return;
    }
    const catalogue = document.querySelector('[data-catalogue]');
    if (catalogue && /^\/collections\/all\/?$/.test(location.pathname)) catalogue.querySelector('h1').textContent = 'Equipos y accesorios';
    document.querySelectorAll('[data-accessory-product]').forEach(product => {
      if (product.dataset.accessoryReady) return;
      product.dataset.accessoryReady = 'true';
      const main = product.querySelector('.saa-main-photo');
      const dialog = product.querySelector('.saa-dialog');
      product.querySelectorAll('[data-accessory-photo]').forEach(button => button.addEventListener('click', () => {
        main.removeAttribute('srcset');
        main.src = button.dataset.accessoryPhoto;
        main.alt = button.dataset.alt || '';
        product.querySelectorAll('[data-accessory-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      product.querySelector('[data-accessory-zoom]')?.addEventListener('click', () => {
        const image = dialog.querySelector('img');
        image.src = main.currentSrc || main.src;
        image.alt = main.alt;
        dialog.showModal();
      });
      dialog?.querySelector('[data-accessory-close]').addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const select = product.querySelector('[data-accessory-variant]');
      if (select) {
        const variants = JSON.parse(product.querySelector('[data-accessory-variants]').textContent);
        select.addEventListener('change', () => {
          const variant = variants.find(v => String(v.id) === select.value);
          if (!variant) return;
          product.querySelector('[data-accessory-price]').textContent = money.format(variant.price / 100);
          product.querySelector('[data-accessory-sku]').textContent = variant.sku;
          const add = product.querySelector('[data-purchase-add]');
          const status = product.querySelector('[data-purchase-status]');
          if (add && status) {
            const quantity = product.querySelector('[name="quantity"]');
            const max = select.selectedOptions[0].dataset.max;
            if (max) {
              quantity.max = max;
              if (Number(max) > 0) quantity.value = String(Math.min(Math.max(1, Number(quantity.value) || 1), Number(max)));
            } else quantity.removeAttribute('max');
            add.disabled = !variant.available;
            add.textContent = variant.available ? add.dataset.available : add.dataset.unavailable;
            status.textContent = !variant.available ? status.dataset.outOfStock : select.selectedOptions[0].dataset.backorder === 'true' ? status.dataset.backorder : status.dataset.inStock;
          }
          product.querySelector('[data-accessory-quote]').href = '/pages/contact?' + new URLSearchParams({producto: product.dataset.product, variante: variant.sku});
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
        });
      }
    });
    const select = document.getElementById('SAProduct');
    const handle = params.get('producto');
    if (select && handle && handle !== 'accesorios' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle) && !select.dataset.accessoryLoading) {
      select.dataset.accessoryLoading = 'true';
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(response => {
        if (!response.ok) throw new Error('Producto no disponible');
        return response.json();
      }).then(product => {
        const requestedSku = params.get('variante');
        const variant = product.variants.find(item => item.sku === requestedSku);
        const value = product.title + (variant ? ' · ' + variant.sku + (variant.public_title ? ' · ' + variant.public_title : '') : '');
        let option = Array.from(select.options).find(item => item.dataset.handle === handle);
        if (!option) { option = document.createElement('option'); option.dataset.handle = handle; select.append(option); }
        option.value = value; option.textContent = value; select.value = value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }).catch(() => { delete select.dataset.accessoryLoading; });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
